import React, { useEffect, useState } from "react";
import { getWalletDetails } from "../utils/API/getWalletDetails";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";

const useWallet = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [walletDetails, setWalletDetails] = useState({
    balance: 0,
    _id: null,
    currency: "INR",
    settled_amount: 0,
    unsettled_amount: 0,
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const { data } = await getWalletDetails(dispatch);
        setWalletDetails(data);
      } catch (error) {
        toast.error(error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  return [loading, walletDetails, setWalletDetails];
};

export default useWallet;
